import { Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import InputComponent from "../../components/Input";
import SelectComponent from "../../components/Select";
import { BankSlipIcon } from "../../styles/icons/BankSlipIcon";

export function BankSlipSection({ organizateRateOld, setOrganizateRateNew, resetTrigger, onEdit }) {
  const [bankSlipOld, setBankSlipOld] = useState(null);
  const [bankSlipNew, setBankSlipNew] = useState(null);
  const [typeValue, setTypeValue] = useState<string>(bankSlipOld?.rates?.[0]?.paymentFeeType)

  useEffect(() => {
    if (organizateRateOld?.GLOBAL) {
      const foundBankSlip = organizateRateOld.GLOBAL.find(
        (item) => item.paymentMethodModel?.name === "BANK_SLIP"
      );


      if (foundBankSlip) {
        setBankSlipOld(foundBankSlip);
        setTypeValue(foundBankSlip?.rates?.[0]?.paymentFeeType)
        setBankSlipNew(JSON.parse(JSON.stringify(foundBankSlip)));
      }
    }
  }, [organizateRateOld, resetTrigger]);

  useEffect(() => {

    if (bankSlipOld) {
      setBankSlipNew(JSON.parse(JSON.stringify(bankSlipOld)));
    }
  }, [bankSlipOld]);


  function handleInputChange(field, newValue) {
    if (!bankSlipNew) return;
    setBankSlipNew((prevBankSlip) => {
      if (!prevBankSlip) return prevBankSlip;

      const updatedBankSlip = structuredClone(prevBankSlip);

      switch (field) {
        case "repaymentDay":
          updatedBankSlip.repaymentDayModel.day = newValue;
          break;
        case "paymentFeeValue":
          updatedBankSlip.rates[0].paymentFeeValue = newValue;
          break;
        case "rateLimitValue":
          updatedBankSlip.rates[0].rateLimitValue = newValue;
          break;
        case "paymentFeeType":
          updatedBankSlip.rates[0].paymentFeeType = newValue;
          break;
        default:
          break;
      }

      return updatedBankSlip;
    });

    setOrganizateRateNew((prevRates) => {
      if (!prevRates?.GLOBAL) return prevRates;

      const updatedRates = JSON.parse(JSON.stringify(prevRates));
      const bankSlipEntry = updatedRates.GLOBAL.find(
        (item) => item.paymentMethodModel?.name === "BANK_SLIP"
      );

      if (bankSlipEntry) {
        if (field === "repaymentDay") bankSlipEntry.repaymentDayModel.day = newValue;
        if (field === "paymentFeeValue") bankSlipEntry.rates[0].paymentFeeValue = newValue;
        if (field === "rateLimitValue") bankSlipEntry.rates[0].rateLimitValue = newValue;
        if (field === "paymentFeeType") bankSlipEntry.rates[0].paymentFeeType = newValue;
      }

      return updatedRates;
    });
  }

  if (!bankSlipNew) {
    return <Text>Carregando...</Text>;
  }

  return (
    <Flex flexDir="column" gap="26px">
      <Flex gap=".4rem">
        <BankSlipIcon size={24} />
        <Text fontFamily="Hero New" fontWeight="600" fontSize="16px" color="#000000" >Boleto</Text>
      </Flex>

      <Flex gap="34px">
        <InputComponent
          topLabel="Tempo de repasse"
          onChange={(newValue) => handleInputChange("repaymentDay", newValue)}
          isTransferTime={true}
          value={bankSlipNew?.repaymentDayModel?.day || ""}
          onEdit={onEdit}
        />

        <InputComponent
          topLabel="Taxa"
          isLimit={typeValue === "VALUE" ? true : null}
          isPercentage={typeValue === "PERCENTAGE" ? true : null}
          onChange={(newValue) => handleInputChange("paymentFeeValue", newValue)}
          value={bankSlipNew?.rates?.[0]?.paymentFeeValue || ""}
          onEdit={onEdit}
        />
        <InputComponent
          isLimit={true}
          topLabel="Limite de taxas"
          onChange={(newValue) => handleInputChange("rateLimitValue", newValue)}
          value={bankSlipNew?.rates?.[0]?.rateLimitValue || ""}
          onEdit={onEdit && typeValue !== "VALUE"}
        />

        <SelectComponent
          topLabel="Tipo de taxa"
          width="262px"
          value={bankSlipNew?.rates?.[0]?.paymentFeeType || ""}
          array={[
            { name: "Valor fixo", value: "VALUE", id: 1 },
            { name: "Porcentagem", value: "PERCENTAGE", id: 2 },
          ]}
          onChange={(newValue) => {
            handleInputChange("paymentFeeType", newValue);
            setTypeValue(String(newValue));
          }}
          onEdit={onEdit}
        />
      </Flex>
    </Flex>
  );
}
